module.exports = __webpack_public_path__ + "static/img/count_content.10e0d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestival/dialog/count_content.png
// module id = 4IcS
// module chunks = 1